import { PlanningEvent } from "../models/planning-event.model";

/**
 * Clé courte unique qui identifie le **type** d'un event (au-delà de
 * `event.source` car on distingue OF prod / OF Prépa PDC / OF Réinte PDC,
 * et BL / Chargement).
 *
 * Utilisée par :
 * - le mapping CSS de la chip source (couleur)
 * - le filtre multi-select "Sources affichées" du menu réglages
 */
export type PlanningSourceKey =
  | "commande"
  | "commande-client"
  | "of"
  | "pdc-prepa"
  | "pdc-reinte"
  | "dechargement"
  | "expedition"
  | "chargement"
  | "facture-client"
  | "lot-mouvement";

export function getEventSourceKey(event: PlanningEvent): PlanningSourceKey {
  if (event.source === "of") {
    if (event.kind === "pdc-prepa") return "pdc-prepa";
    if (event.kind === "pdc-reinte") return "pdc-reinte";
    return "of";
  }
  if (event.source === "expedition") {
    return event.kind === "chargement" ? "chargement" : "expedition";
  }
  return event.source as PlanningSourceKey;
}

/**
 * Métadonnées d'affichage des sources pour le menu de filtres.
 * Order = ordre d'affichage dans le menu.
 */
export interface PlanningSourceMeta {
  key: PlanningSourceKey;
  label: string;
  icon: string;
}

export const PLANNING_SOURCE_META: PlanningSourceMeta[] = [
  { key: "commande", label: "Fournis.", icon: "local_shipping" },
  { key: "commande-client", label: "Client", icon: "shopping_cart" },
  { key: "of", label: "OF", icon: "factory" },
  { key: "pdc-prepa", label: "Prépa PDC", icon: "inventory_2" },
  { key: "pdc-reinte", label: "Réinte PDC", icon: "u_turn_left" },
  { key: "dechargement", label: "Récep.", icon: "input" },
  { key: "expedition", label: "Expé", icon: "outbox" },
  { key: "chargement", label: "Charg.", icon: "directions_truck" },
  { key: "facture-client", label: "Fact. client", icon: "receipt" },
  { key: "lot-mouvement", label: "Lot", icon: "swap_horiz" },
];
